export default __webpack_public_path__ + "static/media/fastener-placement-rounded-rectangle-2-breaks.0ea0fc6d.webp";